export default __webpack_public_path__ + "static/CGV-formations-pro-WealCome-e69b6afe6ae647b7eaedb7e7f1b0c42f.pdf";